module.exports = global["underscore"] = require("-!.\\index.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?underscore!./~/lodash/index.js
// module id = 45
// module chunks = 0